import { LockModalCouponCodes } from '../../constants/lockModal'
import { LockModalVariants } from '@dtx-company/inter-app/src/constants/lockModal'
import { sendNotification } from '@dtx-company/inter-app/src/utils/notifications'
import { useFlowFeature } from '@dtx-company/inter-app/src/hooks/useFlowFeature/useFlowFeature'
import { useRouter } from 'next/router'

export interface UseCouponCodeReturn {
  code?: string
  subtext?: string
  setPromoCode(): void
}

export const usePromoCodeCoupon = (
  variant?: LockModalVariants
): UseCouponCodeReturn | undefined => {
  const { gate, code, subtext } = (variant && LockModalCouponCodes[variant]) || {}
  const [isCouponActive] = useFlowFeature(gate || 'off')
  const router = useRouter()

  const setPromoCode = (): void => {
    try {
      sendNotification({
        message: `applying ${code} promo...`,
        type: 'default'
      })
    } finally {
      router.replace(
        {
          query: { promoCode: code }
        },
        undefined,
        { shallow: true }
      )
    }
  }
  return isCouponActive ? { code, subtext, setPromoCode } : undefined
}
